import React, { useContext } from 'react';
import { Box, CardContent, CardMedia, makeStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { getTranslation, Tr } from '@lsoft/translate';
import { MuiFormatPrice } from '@lsoft/mui';
import { trPreviousPrice } from './Product.tr';
import { ProductLabels } from './ProductLabels';
import { NextAssetImage } from '@lsoft/shared/components/ui/NextAssetImage';
import { ProductContext } from '@lsoft/shared/container/Product';
import { ShopProductLink } from '../../container/shop/ShopProduct';
import { useRouter } from 'next/router';

const useStyles = makeStyles((theme) => ({
	shopGridProductThumbnail: {
		position: 'relative',
		padding: theme.spacing(2),
	},
	shopGridProductLabels: {
		position: 'absolute',
		bottom: 0,
		left: theme.spacing(2),
	},
	shopGridProductName: {
		lineHeight: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box',
		lineClamp: 2,
		boxOrient: 'vertical',
		minHeight: theme.spacing(4),
	},
}));

export const ShopGridProduct = ({ theme }) => {
	const classes = useStyles(theme);
	const { locale } = useRouter();
	const {
		data: {
			brutto_sp,
			real_brutto_sp,
			currency,
			name_text,
			mname,
			msku,
			product_main_picture,
			discount_available,
		},
	} = useContext(ProductContext);

	const name_translation = getTranslation(name_text, locale);

	return (
		<ShopProductLink fullWidth>
			<Card>
				<CardActionArea>
					<CardMedia
						className={clsx(classes.shopGridProductThumbnail)}
						component="div"
					>
						<NextAssetImage
							asset={product_main_picture}
							alt={`${name_translation} (${msku})`}
							sm
						/>
						<Box className={clsx(classes.shopGridProductLabels)}>
							<ProductLabels />
						</Box>
					</CardMedia>
					<CardContent style={{ paddingTop: 8 }}>
						<Typography variant="subtitle2" component="h3">
							{mname}
						</Typography>
						<Typography
							variant={'subtitle1'}
							component={'h2'}
							gutterBottom
							className={clsx(classes.shopGridProductName)}
						>
							{name_translation}
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
						>
							<Grid item>
								<Typography variant="h6" component="div">
									<MuiFormatPrice currency={currency} value={real_brutto_sp} />
								</Typography>
							</Grid>
							{discount_available && (
								<Grid item>
									<Typography
										variant="caption"
										component="div"
										style={{ lineHeight: 1 }}
									>
										<Tr tr={trPreviousPrice} />
										:<br />
										<del>
											<MuiFormatPrice currency={currency} value={brutto_sp} />
										</del>
									</Typography>
								</Grid>
							)}
						</Grid>
					</CardContent>
				</CardActionArea>
			</Card>
		</ShopProductLink>
	);
};
